module.exports = __webpack_public_path__ + "media/images/guideline/B05-7157806327fb8c3e13ac0181543f7680.jpg";